import React, { useRef, useState } from 'react'
import { styleClass } from '../utils/helpers'
import { rarityLabels, statusLabels } from '../data/translations'
import { sanitizeHtml } from '../utils/html'
import { downloadElementScreenshot } from '../utils/shareImage'

const ShareIcon = () => (
  <svg
    className="share-button-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" />
    <path d="M12 16V4" />
    <path d="m7 9 5-5 5 5" />
  </svg>
)

const Location = ({ item, language }) => {
  const locationRef = useRef(null)
  const [isSharing, setIsSharing] = useState(false)
  const name = language === 'EN' ? item.nameEN : item.name
  const descr = language === 'EN' ? item.descrEN : item.descr
  const rarity = rarityLabels[language][item.rarity]
  const status = statusLabels[language][item.status]
  const shareLabel = language === 'EN' ? 'Share location image' : 'Поделиться изображением локации'

  const handleShare = async () => {
    if (isSharing) return

    setIsSharing(true)
    try {
      await downloadElementScreenshot({
        element: locationRef.current,
        filenameBase: name,
        type: 'location',
      })
    } catch (error) {
      console.error('Failed to create location image', error)
      alert(language === 'EN' ? 'Could not create the image.' : 'Не удалось создать изображение.')
    } finally {
      setIsSharing(false)
    }
  }

  return (
    <div className="location" ref={locationRef}>
      <button
        type="button"
        className="item-share-button"
        onClick={handleShare}
        aria-label={shareLabel}
        title={shareLabel}
        disabled={isSharing}
      >
        <ShareIcon />
      </button>

      <img
        src={process.env.PUBLIC_URL + item.imgUrl}
        alt={name}
        className="location-image"
        loading="lazy"
      />

      <div
        className={`location-rarity ${styleClass(rarityLabels.EN[item.rarity])}`}
      >
        {rarity}
      </div>

      <div
        className={`location-status ${styleClass(statusLabels.EN[item.status])}`}
      >
        {status}
      </div>

      <h3 className="location-name" dangerouslySetInnerHTML={{ __html: sanitizeHtml(name) }} />
      <div className="location-descr" dangerouslySetInnerHTML={{ __html: sanitizeHtml(descr) }} />
    </div>
  )
}

export default Location
